import React from 'react'
import shortid from 'shortid'
import Section from '../molecules/Section'
import { Ul, Li } from '../atoms/Lists'
import ActionBar from '../molecules/ActionBar'
import styles from './SectionResources.module.css'

export interface ResourceLink {
  title: string
  url: string
}

export interface ResourceProminent extends ResourceLink {
  description: string
}

export default function SectionResources({
  title,
  resources
}: {
  title: string
  resources: {
    prominent?: ResourceProminent[]
    links: ResourceLink[]
  }
}) {
  return (
    <Section title={title} headerCenter>
      {resources.prominent && (
        <ActionBar actions={resources.prominent} className={styles.prominent} />
      )}

      <Ul className={styles.grid}>
        {resources.links.length > 1 &&
          resources.links.map((link) => (
            <Li key={shortid.generate()}>
              <a className={styles.link} href={link.url}>
                {link.title}
              </a>
            </Li>
          ))}
      </Ul>
    </Section>
  )
}
